import { gql } from '@apollo/client';

export const GET_OPERATIONAL_DASHBOARD = gql`
	query GetOperationalDashboard(
            $start_date: String
            $end_date: String
        ) {
		getOperationalDashboard(
            start_date: $start_date
            end_date: $end_date
        ) {
            activeLives
            inactiveLives
            pregnantRisk {
                low
                high
                high_pc
            }
            formsComparasion {
                finished
                awaiting
            }
            initialFormsComparasion {
                finished
                awaiting
            }
            secondQuarterFormsComparasion {
                finished
                awaiting
            }
            thirdQuarterFormsComparasion {
                finished
                awaiting
            }
            afterBirthFormsComparasion {
                finished
                awaiting
            }
            afterBirthRisk {
                low
                medium
                high
            }
            lateAfterBirthFormsComparasion  {
                finished
                awaiting
            }
            lateAfterBirthRisk {
                low
                medium
                high
            }
        }
	}
`;
